import React, { useState, useEffect } from 'react';
import './App.css';
import Login from './components/Login';

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [items, setItems] = useState([]);
  const [selectedItem, setSelectedItem] = useState('');
  const [startDate, setStartDate] = useState(new Date().toISOString().split('T')[0]);
  const [endDate, setEndDate] = useState(new Date().toISOString().split('T')[0]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [searchResult, setSearchResult] = useState(null);

  useEffect(() => {
    fetchItems();
  }, []);

  const fetchItems = async () => {
    try {
      setLoading(true);
      const response = await fetch('https://xawjonslbmxowekg7hlt5kyxou0sskfg.lambda-url.ap-northeast-2.on.aws/',
        {
          headers: {
            'Authorization': `Bearer ${sessionStorage.getItem("accessToken")}`
          }
        }
      );
      if (!response.ok) {
        throw new Error('데이터를 불러오는데 실패했습니다.');
      }
      const data = await response.json();
      setItems(data.result)
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleItemChange = (event) => {
    setSelectedItem(event.target.value);
  };

  const handleStartDateChange = (event) => {
    setStartDate(event.target.value);
  };

  const handleEndDateChange = (event) => {
    setEndDate(event.target.value);
  };

  const handleSearch = async () => {
    if (!selectedItem || !startDate || !endDate) {
      setError('모든 항목을 선택해주세요.');
      return;
    }

    try {
      setLoading(true);
      setError(null);
      setSearchResult(null);
      
      const searchParams = {
        domain: selectedItem,
        start_date: startDate,
        end_date: endDate
      };

      const response = await fetch('https://l2vpnc5pjhxo25t2u4brfqalai0jqnqu.lambda-url.ap-northeast-2.on.aws/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${sessionStorage.getItem("accessToken")}`
        },
        body: JSON.stringify(searchParams),
        mode: "cors"
      });
      if (response.status === 403) {
        setIsLoggedIn(false);
        setError('다시 로그인 해주세요.');
        return;
      }
      if (!response.ok) {
        throw new Error(`검색에 실패했습니다. (${response.status})`);
      }

      try {
        const data = await response.json();
        setSearchResult(data);
      } catch (parseError) {
        console.log("parseError", parseError);
        throw new Error('서버 응답을 파싱할 수 없습니다.');
      }
    } catch (err) {
      setError(err.message);
      console.error('검색 중 오류 발생:', err);
      console.log(err.message)
    } finally {
      setLoading(false);
    }
  };

  const formatNumber = (num) => {
    return new Intl.NumberFormat('ko-KR').format(num);
  };

  return (
    <div className="App">
      {!isLoggedIn ? (
        <Login onLogin={setIsLoggedIn} />
      ) : (
        <header className="App-header">
          <h1>항목 선택</h1>
          {loading && <p className="loading">로딩 중...</p>}
          {error && <p className="error">{error}</p>}
          <div className="selection-container">
            <div className="dropdown-container">
              <select 
                value={selectedItem} 
                onChange={handleItemChange}
                className="user-dropdown"
              >
                <option value="">항목을 선택하세요</option>
                {items.map((item, index) => (
                  <option key={index} value={item}>
                    {item}
                  </option>
                ))}
              </select>
            </div>
            <div className="date-container">
              <div className="date-input">
                <label htmlFor="startDate">시작일:</label>
                <input
                  type="date"
                  id="startDate"
                  value={startDate}
                  onChange={handleStartDateChange}
                  className="date-picker"
                />
              </div>
              <div className="date-input">
                <label htmlFor="endDate">종료일:</label>
                <input
                  type="date"
                  id="endDate"
                  value={endDate}
                  onChange={handleEndDateChange}
                  className="date-picker"
                  min={startDate}
                />
              </div>
            </div>
            <button 
              onClick={handleSearch}
              className="search-button"
              disabled={loading}
            >
              조회
            </button>
          </div>
          {(selectedItem || startDate || endDate) && (
            <div className="selected-info">
              <h2>선택된 정보</h2>
              {selectedItem && <p>선택된 항목: {selectedItem}</p>}
              {startDate && <p>시작일: {startDate}</p>}
              {endDate && <p>종료일: {endDate}</p>}
            </div>
          )}
          {searchResult && (
            <div className="search-result">
              <h2>검색 결과</h2>
              <div className="result-grid">
                <div className="result-item">
                  <h3>납품 금액</h3>
                  <p className="result-value">{formatNumber(searchResult.total_delivery)}원</p>
                </div>
                <div className="result-item">
                  <h3>은행 반납 금액</h3>
                  <p className="result-value">{formatNumber(searchResult.bank_return)}원</p>
                </div>
                <div className="result-item">
                  <h3>포인트 반납 금액</h3>
                  <p className="result-value">{formatNumber(searchResult.point_return)}원</p>
                </div>
                <div className="result-item">
                  <h3>법인 반납 금액</h3>
                  <p className="result-value">{formatNumber(searchResult.corp_return)}원</p>
                </div>
                <div className="result-item">
                  <h3>현금 반납 금액</h3>
                  <p className="result-value">{formatNumber(searchResult.cash_return)}원</p>
                </div>
                <div className="result-item">
                  <h3>반환율</h3>
                    <p className="result-value">{formatNumber((searchResult.bank_return + searchResult.point_return + searchResult.corp_return+searchResult.cash_return)/searchResult.total_delivery * 100)}%</p>
                </div>
              </div>
            </div>
          )}
        </header>
      )}
    </div>
  );
}

export default App;
